import qs from 'qs';
import fetch from '../fetch';
import url from './beike-url';
// import mock from './mock';

const noloading = true;

export default {
  // 权限判断
  getPageAccess() {
    // @mock
    // console.log('@mock, access:', mock.newAccess);
    // return Promise.resolve(mock.newAccess);
    return fetch({
      url: url.getPageAccess,
      method: 'get',
    });
  },
  // 顶部菜单栏
  getMenu() {
    // @mock
    // console.log('@mock, userinfo:', mock.newUser);
    // return Promise.resolve(mock.newUser);
    return fetch({
      url: url.getMenu,
      method: 'get',
    });
  },
  // 获取班级数量
  getClassNum() {
    // @mock
    // console.log('@mock, classnum:', mock.newClassNum);
    // return Promise.resolve(mock.newClassNum);
    return fetch({
      url: url.getClassNum,
      method: 'get',
    });
  },
  // 获取班级筛选项
  getMyCondition() {
    // @mock
    // console.log('@mock, criterion:', mock.newCriterion);
    // return Promise.resolve(mock.newCriterion);
    return fetch({
      url: url.getMyCondition,
      method: 'get',
    });
  },
  // 获取我的班级及课程历史记录
  getMyClassAndType(params: any) {
    // @mock
    // console.log('@mock, newClassList:', mock.newClassList);
    // return Promise.resolve(mock.newClassList);
    return fetch({
      url: url.getMyClassAndType,
      method: 'get',
      params,
    });
  },
  // 获取上次备课记录
  getLastLesson() {
    return fetch({
      url: url.getLastLesson,
      method: 'get',
    });
  },
  // 猜你想要合并接口
  getFastClass() {
    return fetch({
      url: url.getFastClass,
      method: 'get',
    });
  },
  // 删除班型
  delClassType(classTypeId: string) {
    return fetch({
      url: `${url.delClassType}/${classTypeId}`,
      method: 'delete',
    });
  },
  // 搜索班型
  searchClassType(params: object) {
    return fetch({
      url: url.searchClassType,
      method: 'get',
      params,
    });
  },
  // ab测试接口
  abTest(params: object) {
    return fetch({
      url: url.abTest,
      method: 'get',
      params,
    });
  },
  // ================================================= 以上是修改过的接口

  getOption(params: object) {
    return fetch({
      url: url.getOption,
      method: 'get',
      params,
    });
  },
  verification() {
    return fetch({
      url: url.verification,
      method: 'get',
    });
  },
  // 获取科目
  getSubject() {
    return fetch({
      url: url.getSubject,
      method: 'get',
    });
  },
  // 保存用户选择班级（班级）记录
  saveHistory(data: any) {
    return fetch({
      url: url.saveHistory,
      method: 'post',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      data: qs.stringify(data),
    });
  },
  /**
   * @desc 获取讲次截图列表
   * */
  getBanshuList(params: any) {
    return fetch({
      url: url.getBanshuList,
      method: 'get',
      params,
    });
  },
  // 获取课程合照相册列表
  getPhotoList(params: any) {
    return fetch({
      url: url.getPhotoList,
      method: 'get',
      params,
    });
  },
  // 获取班型列表
  getClassTypeList(params: any) {
    return fetch({
      url: url.getClassTypeList,
      method: 'get',
      params,
    });
  },
  // 获取学科的科目
  getSubjectPro(subjectId: any) {
    return fetch({
      url: `${url.getSubjectPro}/${subjectId}`,
      method: 'get',
    });
  },
  // 获取筛选条件
  getCondition(subjectId: string, subjectPro: string) {
    return fetch({
      url: `${url.getCondition}/${subjectId}/${subjectPro}`,
      method: 'get',
    });
  },

  // 获取讲次列表
  getLessonList(params: any) {
    return fetch({
      url: `${url.getLessonList}/${params.businessId}/${params.type}/${params.newDiyFlag}/lessonList`,
      method: 'get',
    });
  },
  // 即将上课提醒
  getComingClass() {
    return fetch({
      url: url.getComingClass,
      method: 'get',
      noloading,
    });
  },
  getAdminList() {
    return fetch({
      url: url.getAdminList,
      method: 'get',
    });
  },
  getDetail(data: any) {
    return fetch({
      url: url.getDetail,
      method: 'post',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      data: qs.stringify(data),
    });
  },
  getHandoutTopic(data: any) {
    return fetch({
      url: url.getHandoutTopic,
      method: 'post',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      data: qs.stringify(data),
    });
  },
  getExamArea(data: any) {
    return fetch({
      url: url.getExamArea,
      method: 'post',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      data: qs.stringify(data),
    });
  },
  saveExamArea(data: any) {
    return fetch({
      url: url.saveExamArea,
      method: 'post',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      data: qs.stringify(data),
    });
  },
  getStudentHomeworkTopicInfo(data: any) {
    return fetch({
      url: url.getStudentHomeworkTopicInfo,
      method: 'post',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      data: qs.stringify(data),
    });
  },
  getStudentRatioInfo(data: any) {
    return fetch({
      url: url.getStudentRatioInfo,
      method: 'post',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      data: qs.stringify(data),
    });
  },

  /**
   * @description: 获取精准学班级列表
   * @param {any} params
   * @return {*}
   */
  getAccurateList(params: any) {
    // @mock
    // console.log('@mock, accurateList:', mock.accurateList, params);
    // return Promise.resolve(mock.accurateList.body);
    return fetch({
      url: url.getAccurateList,
      method: 'get',
      params,
    });
  },

  /**
   * @description: 获取课件接口
   * @param {any} params
   * @return {*}
   */
  getCoursewareList(params: any) {
    return fetch({
      url: `${url.getAccurateList}/${params.classId}/course/${params.courseType}`,
      method: 'get',
    });
  },

  /**
   * @description: 查询自定义讲次列表
   * @param {any} params
   * @return {*}
   */
  getCoustomList(params: any) {
    return fetch({
      url: `${url.getAccurateList}/${params.classId}/lessons`,
      method: 'get',
    });
  },

  /**
   * @description: 创建自定义讲次
   * @param {any} params
   * @return {*}
   */
  addCustomLesson(data: any) {
    return fetch({
      url: `${url.getAccurateList}/lessons/createLesson`,
      method: 'post',
      // headers: {
      //   'Content-Type': 'application/x-www-form-urlencoded',
      // },
      data,
    });
  },

  /**
   * @description: 回显已选知识点接口
   * @param {any} params
   * @return {*}
   */
  getKnowledgeParentList(params: any) {
    return fetch({
      url: url.knowledgeParentList,
      method: 'get',
      params,
    });
  },

  /**
   * @description: 更新讲次信息
   * @param {any} data
   * @return {*}
   */
  changeLesson(data: any) {
    return fetch({
      url: url.changeLesson,
      method: 'post',
      // headers: {
      //   'Content-Type': 'application/x-www-form-urlencoded',
      // },
      data,
    });
  },
  getMsClassReviewInfo(params: any) {
    return fetch({
      url: url.getMsClassReviewInfo,
      method: 'get',
      params,
    });
  },
  getMsClassStudentReviewDetail(params: any) {
    return fetch({
      url: url.getMsClassStudentReviewDetail,
      method: 'get',
      params,
    });
  },
  msPcTopicReEvaluation(data: any) {
    return fetch({
      url: url.msPcTopicReEvaluation,
      method: 'post',
      data,
    });
  },
  getBkClassList(params: any) {
    return fetch({
      url: url.getBkClassList,
      method: 'post',
      data: params,
    });
  },

  getBkLessonList(params: any) {
    // 确保所有参数都被替换
    const apiUrl = url.getBkLessonList
      .replace('{businessId}', params.businessId)
      .replace('{type}', params.type)
      .replace('{newDiyFlag}', params.newDiyFlag);
    return fetch({
      url: apiUrl,
      method: 'get',
    });
  },

  getBkLessonView(params: any) {
    return fetch({
      url: url.getBkLessonView,
      method: 'post',
      data: params,
    });
  },
  getMsClassStudentReviewDetailNew(params: any) {
    return fetch({
      url: url.getMsClassStudentReviewDetailNew,
      method: 'post',
      data: params,
    });
  },

  getMsClassLessonReviewInfo(params: any) {
    return fetch({
      url: url.getMsClassLessonReviewInfo,
      method: 'post',
      data: params,
    });
  },
  // 获取学生专属练数据
  getExclusivePracticeInfo(params: any) {
    return fetch({
      url: url.getExclusivePracticeInfo,
      method: 'post',
      data: params,
    });
  },
  // 学生视角导出
  exportMsClassLessonReviewInfo(params: any) {
    return fetch({
      url: url.exportMsClassLessonReviewInfo,
      method: 'post',
      data: params,
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
      },
      // 添加标记，表示这是文件下载
      isFileDownload: true,
    });
  },
  // 讲次视角导出
  exportMsClassLessonReviewInfoNew(params: any) {
    return fetch({
      url: url.exportMsClassLessonReviewInfoNew,
      method: 'post',
      data: params,
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
      },
      // 添加标记，表示这是文件下载
      isFileDownload: true,
    });
  },
  // 修改练习题结果
  msPcTopicUpdate(params: any) {
    return fetch({
      url: url.msPcTopicUpdate,
      method: 'post',
      data: params,
    });
  },
  // 获取二维码内容
  getQrCodeUrl(params: any) {
    return fetch({
      url: url.getQrCodeUrl,
      method: 'post',
      data: params,
      headers: {
        'Content-Type': 'application/json',
        'Atlas-Token': 'EVKgR0eb',
        'Atlas-TokenKey': '100010',
      },
    });
  },
  // 获取classCode
  getClassCode(params: any) {
    const apiUrl = url.getClassCode
      .replace('{classId}', params);
    return fetch({
      url: apiUrl,
      method: 'get',
    });
  },
};
